import React, { useState, useEffect, useContext } from "react";
import { Alert, FormText } from "reactstrap";
import { Link } from "react-router-dom";
import ViewLayout from "../../components/viewLayout";
import TableHelper from "../../components/tableHelper";
import StripeSubscriptionProductsTable from "../../components/stripeSubscriptionProductsTable";
import SubscriptionsFeatureLockAlerts from "../../components/subscriptionsFeatureLockAlerts";
import { stripeSubscriptionService } from "../../jwt/_services/stripeSubscription.service";
import { isSubscriptionFeatureLocked } from "../../utils/subscriptionUtils";
import { StateContext } from "../../utils/context";
import TenantContext from "../../utils/tenantContext";

const StripeSubscriptionProducts = () => {
  const { currentUser } = useContext(StateContext);
  const { tenant } = useContext(TenantContext);
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState(false);
  const [error, setError] = useState("");

  const [config, setConfig] = useState(null);
  const [products, setProducts] = useState([]);

  const featureLocked = isSubscriptionFeatureLocked(tenant, currentUser?.sla_level);

  useEffect(() => {
    setLoading(true);
    setFetchError(false);
    setError("");
    Promise.all([
      stripeSubscriptionService.getConfig(),
      stripeSubscriptionService.listProducts(),
    ])
      .then(([configData, productsData]) => {
        setConfig(configData);
        setProducts(productsData.results || productsData || []);
      })
      .catch(() => {
        setFetchError(true);
        setError("Failed to load subscription products.");
      })
      .finally(() => setLoading(false));
  }, []);

  const atProductLimit = products.length >= 5;
  const stripeConnected = config?.has_secret_key;

  if (loading) {
    return <TableHelper loading />;
  }

  if (fetchError) {
    return <TableHelper error />;
  }

  return (
    <>
      {featureLocked && (
        <SubscriptionsFeatureLockAlerts tenant={tenant} slaLevel={currentUser?.sla_level} />
      )}

      {!featureLocked && !stripeConnected && (
        <Alert color="warning">
          Connect your Stripe account in <Link to="/subscription-config">Subscription Configuration</Link> before managing products.
        </Alert>
      )}

      <ViewLayout title="Subscription Products">
        <StripeSubscriptionProductsTable tableData={products} featureLocked={featureLocked} />
        {atProductLimit && (
          <FormText color="muted">Maximum of 5 active subscription plans reached.</FormText>
        )}
      </ViewLayout>

      {error && <Alert color="danger" className="mt-3">{error}</Alert>}
    </>
  );
};

export default StripeSubscriptionProducts;
